import React, { useState } from "react";
import { Option } from "react-select/lib/filters";
import { useTranslation } from "react-i18next";
import useGetShiftOptions from "@modules/shared/selectors/hooks/useGetShiftOptions";
import AdvanceSelector from "../advance-selector";

interface AdvancedShiftSelectorProps {
  onChange?: (option: Option) => void;
  scenario: string;
  shiftOption?: Option;
}

const AdvancedShiftSelector = ({ scenario, onChange, shiftOption }: AdvancedShiftSelectorProps) => {
  const [value, setValue] = useState(shiftOption);

  const { loadOptions } = useGetShiftOptions({
    scenario,
  });

  const { t } = useTranslation();

  return (
    <AdvanceSelector
      isPaginated
      dimension={t("advanced-search.instructor.forms.select-wrapper.shift.label")}
      selectPlaceholder={t("advanced-search.instructor.forms.select-wrapper.shift.placeholder")}
      loadOptions={loadOptions}
      value={value}
      onChange={option => {
        setValue(option);
        onChange?.(option);
      }}
      notShowLabel
    />
  );
};

export default AdvancedShiftSelector;
